export default __webpack_public_path__ + "static/media/sec-3-ar.7ba108a6.png";